<app-loader *ngIf="isLoading | async"></app-loader>
<ng-container *ngIf="!selectedPatient; else carePlanView">
  <div class="pr-tainer patient-page">
    <div class="container">
      <div class="header-row">
        <div>
          <h3 class="page-title">Patients</h3>
          <p class="section-desc">Search for patient by name, device serial number, External ID, or Patient Reference. Minimum of two characters.</p>
        </div>
        <button class="fab" (click)="showAddPatientModal = true">+</button>
      </div>
      <div *ngIf="notification?.show" class="notification-bar" [ngClass]="notification.type">
        <span>{{ notification.message }}</span>
        <button class="notification-close" (click)="notification.show = false">&times;</button>
      </div>
      <div class="search-box">
        <form #searchForm="ngForm" (ngSubmit)="searchPatients(searchForm.value.searchName, searchForm.value.searchDob, searchForm.value.searchPostal, searchForm.value.searchPhone, patientSearchTypes)">
          <label class="search-label">Search by:</label>
          <div class="tab-group">
            <button class="tab active" type="button">Name</button>
            <button class="tab" type="button">Device Serial Number</button>
            <button class="tab" type="button">External ID</button>
            <button class="tab" type="button">Patient Reference</button>
          </div>
          <input name="searchName" ngModel type="text" class="full-width-input" placeholder=" " />
          <a href="#" class="toggle-options" (click)="toggleOptions($event); $event.preventDefault();">
            {{ showMoreOptions ? 'Less Options' : 'More Options' }}
          </a>
          <div *ngIf="showMoreOptions">
            <div class="form-row">
              <div class="form-group">
              <label class="label">Date of Birth</label>
              <input name="searchDob" ngModel type="date" />
              </div>
              <div class="form-group">
              <label class="label">Postal Code</label>
              <input name="searchPostal" ngModel type="text" />
              </div>
              <div class="form-group">
              <label class="label">Phone Number</label>
              <input name="searchPhone" ngModel type="text" />
              </div>
            </div>

            <div class="form-row" style="margin-top: 20px;">
              <div class="form-group">
              <label class="label">Search Type</label>
              <div class="search-type-options">
                  <label><input type="checkbox" name="patientSearchType_exact" (change)="togglePatientSearchType('exact', $any($event.target).checked)" [checked]="patientSearchTypes?.includes('exact')" /> Exact</label>
                  <label><input type="checkbox" name="patientSearchType_partial" (change)="togglePatientSearchType('partial', $any($event.target).checked)" [checked]="patientSearchTypes?.includes('partial')" /> Partial</label>
                  <label><input type="checkbox" name="patientSearchType_fuzzy" (change)="togglePatientSearchType('fuzzy', $any($event.target).checked)" [checked]="patientSearchTypes?.includes('fuzzy')" /> Fuzzy</label>
              </div>
              </div>
            </div>

            <div class="form-row">
              <div class="actions">
                <a href="#" (click)="$event.preventDefault(); searchForm.resetForm(); patientSearchTypes = [];">Clear All</a>
                <button class="search-btn" type="submit">Search</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="patient-list-wrapper">
      <header class="pr-section-header clearfix">
        <div class="section-header-flex">
          <h3 class="section-title">New Patients</h3>
          <p class="section-desc">Patients set up in the last 120 days</p>
        </div>
      </header>
      <div class="header no-gap">
        <div class="toolbar">
          <div class="results-count left-align">
            Showing 1–{{patients.length}} of {{patients.length}} results
          </div>
          <div class="filters">
            <div class="status-filter">
              <label>Patient status:</label>
              <button mat-button [class.active]="selectedStatus === 'Active'" (click)="filterStatus('Active')">Active</button>
              <button mat-button [class.active]="selectedStatus === 'Inactive'" (click)="filterStatus('Inactive')">Inactive</button>
              <button mat-button [class.active]="selectedStatus === 'All'" (click)="filterStatus('All')">All</button>
            </div>
            <div class="sort-filter">
              <label>Sort by:</label>
              <mat-form-field appearance="outline" class="sort-select">
                <mat-select [value]="selectedSort" (selectionChange)="sortPatients($event.value)">
                  <mat-option value="setup">Setup Date</mat-option>
                  <mat-option value="lastName">Last Name</mat-option>
                  <mat-option value="dob">Date of Birth</mat-option>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button (click)="toggleSortDirection()" class="sort-icon" [ngClass]="{'active': sortDirection === 'desc'}">
                <mat-icon>view_list</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!selectedPatient; else carePlanView">
        <div *ngFor="let patient of patients; let i = index" class="patient-card clickable" (click)="openPatientCarePlan(patient)">
          <div class="patient-card compact">
            <div class="card-header">
              <strong class="patient-id">{{ patient.name }}</strong>
            </div>

            <div class="card-body">
              <div class="info-row">
                <div>Date of birth:<span>{{ patient.dob | date }}</span></div>
                <div>Setup date:
                  <span *ngIf="!patientLoading[patient.id]; else setupLoader">{{ patient.setupDate | date }}</span>
                  <ng-template #setupLoader>
                    <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
                  </ng-template>
                </div>
                <div>Serial number:
                  <span *ngIf="!patientLoading[patient.id]; else serialLoader">{{ patient.serialNumber }}</span>
                  <ng-template #serialLoader>
                    <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
                  </ng-template>
                </div>
              </div>

              <div class="info-row">
                <div>Address: <span>{{ patient.address }}</span></div>
                <div>Location:
                  <span *ngIf="!patientLoading[patient.id]; else locationLoader">{{ patient.location }}</span>
                  <ng-template #locationLoader>
                    <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
                  </ng-template>
                </div>
                <div>Device category:
                  <span *ngIf="!patientLoading[patient.id]; else deviceLoader">{{ patient.deviceCategory }}</span>
                  <ng-template #deviceLoader>
                    <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
                  </ng-template>
                </div>
              </div>

              <div class="info-row">
                <div>External ID: <span>{{ patient.patientExternalId }}</span></div>
                <div>Care team:
                  <span *ngIf="!patientLoading[patient.id]; else careLoader">{{ patient.careTeam }}</span>
                  <ng-template #careLoader>
                    <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
                  </ng-template>
                </div>
                <div>Patient reference: <span>{{ patient.patientRef }}</span></div>
              </div>

              <div class="info-row usage-row">
                <div *ngIf="patient.lastUsageDate !== null">Last usage date:
                  <span *ngIf="!patientLoading[patient.id]; else lastUsageLoader">{{ patient.lastUsageDate | date }}</span>
                  <ng-template #lastUsageLoader>
                    <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
                  </ng-template>
                </div>
              </div>
              <div class="info-row">
              <div *ngIf="patient.usage !== null">Uses:
                  <span *ngIf="!patientLoading[patient.id]; else daysUsedLoader">{{ patient.usage }}</span>
                  <ng-template #daysUsedLoader>
                    <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
                  </ng-template>
                </div>
                <div *ngIf="patient.avgHoursPerDay !== null">Avg hours/day:
                  <span *ngIf="!patientLoading[patient.id]; else avgHoursLoader">{{ patient.avgHoursPerDay }}</span>
                  <ng-template #avgHoursLoader>
                    <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
                  </ng-template>
                </div>
                <div>Usage percentage:
                  <span *ngIf="!patientLoading[patient.id]; else usageLoader">{{ patient.usagePercentage }}</span>
                </div>
              </div>
              <ng-template #usageLoader>
                <mat-progress-spinner mode="indeterminate" diameter="18" color="primary" style="display:inline-block;vertical-align:middle;"></mat-progress-spinner>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #carePlanView>
  <app-patient-care-plan [patient]="selectedPatient" (close)="selectedPatient = null"></app-patient-care-plan>
</ng-template>

<div class="modal-backdrop" *ngIf="showAddPatientModal">
  <div class="modal add-patient-modal">
    <div class="modal-header">
      <span class="modal-title">Add Patient</span>
      <button class="modal-close" (click)="showAddPatientModal = false">&times;</button>
    </div>
    <div *ngIf="notification?.show" class="notification-bar" [ngClass]="notification.type">
      <span>{{ notification.message }}</span>
      <button class="notification-close" (click)="notification.show = false">&times;</button>
    </div>
    <div class="modal-tabs">
      <button class="modal-tab" [class.active]="activeTab === 0" (click)="activeTab = 0" [disabled]="false">Identity</button>
      <button class="modal-tab" [class.active]="activeTab === 1" (click)="patientCreated && (activeTab = 1)" [disabled]="!patientCreated">Contact Information</button>
      <button class="modal-tab" [class.active]="activeTab === 2" (click)="patientCreated && (activeTab = 2)" [disabled]="!patientCreated">Care Team</button>
      <button class="modal-tab" [class.active]="activeTab === 3" (click)="patientCreated && (activeTab = 3)" [disabled]="!patientCreated">Equipment</button>
      <button class="modal-tab" [class.active]="activeTab === 4" (click)="patientCreated && (activeTab = 4)" [disabled]="!patientCreated">Rules and Reminders</button>
    </div>
    <div class="modal-body">
      <form *ngIf="activeTab === 0" [formGroup]="identityForm">
        <div class="modal-form-row">
          <label>* Location</label>
          <input type="text" formControlName="location" placeholder="SourceOrg1" />
        </div>
        <div class="modal-form-row">
          <label>* First Name</label>
          <input type="text" formControlName="firstName" />
        </div>
        <div class="modal-form-row">
          <label>* Last Name</label>
          <input type="text" formControlName="lastName" />
        </div>
        <div class="modal-form-row">
          <label>* Date of Birth</label>
          <input type="date" formControlName="dob" />
          <button class="calendar-btn" type="button"></button>
        </div>
        <div class="modal-form-row gender-row">
          <label>* Gender</label>
          <label><input type="radio" formControlName="gender" value="Male" /> Male</label>
          <label><input type="radio" formControlName="gender" value="Female" /> Female</label>
          <label><input type="radio" formControlName="gender" value="Unspecified" /> Unspecified</label>
        </div>
        <div class="modal-form-row">
          <label>* Setup Date</label>
          <input type="date" formControlName="setupDate" [value]="today" />
          <button class="calendar-btn" type="button"></button>
        </div>
        <div class="modal-form-row">
          <label>External ID</label>
          <input type="text" formControlName="externalId" />
        </div>
        <div class="modal-form-row">
          <label>Patient Reference</label>
          <input type="text" formControlName="patientReference" />
        </div>
        <div class="modal-form-row">
          <label>Payer</label>
          <input type="text" formControlName="payer" />
          <button class="search-btn" type="button"></button>
        </div>
        <div class="modal-form-row">
          <label>Secondary Payer</label>
          <input type="text" formControlName="secondaryPayer" />
          <button class="search-btn" type="button"></button>
        </div>
        <div class="modal-form-row">
          <label>Payer Member ID</label>
          <input type="text" formControlName="payerMemberId" />
        </div>
        <div class="modal-form-row">
          <label>Secondary Payer Member ID</label>
          <input type="text" formControlName="secondaryPayerMemberId" />
        </div>
      </form>
      <div *ngIf="activeTab === 1">
        <form [formGroup]="contactForm" class="contact-form-modal">
          <div class="contact-form-grid">
            <div class="form-row">
              <label>Phone number</label>
              <div class="phone-row">
                <input type="text" formControlName="phoneNumber" class="input-phone" />
                <button type="button" class="add-phone-btn">+</button>
              </div>
              <div class="preferred-row">
                <input type="checkbox" formControlName="preferredNumber" id="preferredNumber" />
                <label for="preferredNumber" class="preferred-label">Preferred number</label>
              </div>
            </div>
            <div class="form-row">
              <label>Email address</label>
              <input type="email" formControlName="email" />
            </div>
            <div class="form-row">
              <label>Preferred contact method</label>
              <select formControlName="preferredContactMethod">
                <option value="">Select</option>
                <option value="Phone">Phone</option>
                <option value="Email">Email</option>
              </select>
            </div>
            <div class="form-row">
              <label>Street address</label>
              <input type="text" formControlName="streetAddress" />
            </div>
            <div class="form-row">
              <label>Postal Code</label>
              <input type="text" formControlName="postalCode" />
            </div>
            <div class="form-row">
              <label>City</label>
              <input type="text" formControlName="city" />
            </div>
            <div class="form-row">
              <label>State</label>
              <input type="text" formControlName="state" />
            </div>
            <div class="form-row">
              <label>Country</label>
              <select formControlName="country">
                <option value="United States">United States</option>
                <option value="India">India</option>
              </select>
            </div>
            <div class="form-row">
              <label><span class="required-star">*</span>Time zone</label>
              <select formControlName="timeZone">
                <option value="(GMT-05:00) Eastern Time (US and Canada)">(GMT-05:00) Eastern Time (US and Canada)</option>
                <option value="Asia/Kolkata">Asia/Kolkata</option>
              </select>
            </div>
            <div class="form-row">
              <label>Start time of day</label>
              <input type="text" formControlName="startTime" value="12:00" />
            </div>
          </div>
        </form>
      </div>
      <div *ngIf="activeTab === 2">
        <!-- Care team tab content -->
        <div class="care-team-section">
          <div class="careteam">Assigned Care Team</div>
          <div class="main-container">
            <!-- Left column: Member or location -->
            <div class="column-group left">
              <div class="box heading" style="padding-bottom: 4px;">Member or location</div>
              <mat-divider style="padding-top: 4px; color: rgb(97, 97, 97);"></mat-divider>
              <div class="box heading">PMS User</div>
              <div class="box paragraph" style="color: rgb(1, 111, 1);">
                Customer administrator, Clinical assistant, Patient viewer,
                Administrator, Patient rule administrator, Clinical user, Physician
              </div>
            </div>

            <!-- Right column: Organization -->
            <div class="column-group right">
              <div class="box heading" style="padding-bottom: 4px;">Organization</div>
              <mat-divider style="padding-top: 4px;"></mat-divider>
              <div class="box paragraph">_________</div>
            </div>
          </div>

          <div class="careteam1">Add care team</div>

          <div style="padding-bottom: 10px;">
            <button class="modal-button" [disabled]="false">Internal</button>
            <button class="modal-button" [disabled]="false">External</button>
          </div>

          <div class="box paragraph">Search by physician name or NPI number, or location name or address. Select result
            to add to Care Team. Minimum of two characters.</div>

          <div class="search-row">
            <!-- <div class="search-container">
              <input type="text" placeholder="Search by ???" [(ngModel)]="searchTerm"
                (input)="onSearchChange($event)">
            </div> -->

            <div>
              <button class="btn-save">Assign Care Team</button>
            </div>

            <div class="toggle-group">
              <label class="toggle-option">
                <input type="radio" name="searchType" value="physicians" />
                <span class="custom-radio"></span>
                Physicians
              </label>

              <label class="toggle-option">
                <input type="radio" name="searchType" value="locations" checked />
                <span class="custom-radio"></span>
                Locations
              </label>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="activeTab === 3">
        <!-- Equipment tab content -->

        <div class="square-box">
          <!-- Devices Block Header -->
          <div class="block-title" style="display: flex; align-items: center; justify-content: space-between;">
            <span>Devices</span>
            <button type="button" class="fab" [disabled]="!devicesHidden" (click)="devicesHidden = false"
              *ngIf="devicesHidden">+</button>
          </div>

          <div *ngIf="savedDevices.length === 0 && devicesHidden" class="no-data-msg">
            No Device assigned
          </div>

          <!-- FORM Section (headers + input fields) -->
          <ng-container *ngIf="!devicesHidden">
            <!-- Form Header -->
            <div class="block-one">
              <div class="item">Device</div>
              <div class="item">Serial number</div>
              <div class="item">Assignment date</div>
              <div class="item">Data source</div>
              <div class="item" style="width: 60px;">&nbsp;</div>
              <div class="internal-divider"></div>

              <!-- Form Inputs -->
              <div class="item">
                Generic Device
              </div>

              <div class="item">
                <input type="text" [(ngModel)]="selectedDevice.serialNumber" placeholder="Enter serial No" />
              </div>

              <div class="item">
                <input type="date" [(ngModel)]="selectedDevice.assignmentDate" />
              </div>

              <div class="item">
                <select [(ngModel)]="selectedDevice.dataSource">
                  <option value="" disabled selected>Select source</option>
                  <option value="Connected">Connected</option>
                  <option value="Removable media">Removable media</option>
                  <option value="None">None</option>
                </select>
              </div>
            </div>

            <!-- Buttons -->
            <div class="button-wrapper">
              <div class="btn-group">
                <button class="btn-cancel" (click)="devicesHidden = true">Cancel</button>
                <button class="btn-save" (click)="saveDevice()">Save</button>
              </div>
            </div>
          </ng-container>

          <!-- Divider -->
          <hr class="internal-divider" *ngIf="savedDevices.length > 0" />

          <!-- SAVED DEVICES Section -->
          <div *ngIf="savedDevices.length > 0">
            <div class="block-one">

              <!-- ONLY show headers here if form is hidden -->
              <ng-container *ngIf="devicesHidden">
                <div class="item">Device</div>
                <div class="item">Serial number</div>
                <div class="item">Assignment date</div>
                <div class="item">Data source</div>
                <div class="item" style="width: 60px;">&nbsp;</div>
                <div class="internal-divider"></div>
              </ng-container>

              <!-- Saved Entries -->
              <ng-container *ngFor="let device of savedDevices; let i = index">
                <div class="item">{{ device.device }}</div>
                <div class="item">{{ device.serialNumber }}</div>
                <div class="item">{{ device.assignmentDate }}</div>
                <div class="item">{{ device.dataSource }}</div>
                <div class="item">
                  <!-- <span class="icon" class="pr-icon pr-icon-edit" (click)="editDevice(device)">✏️</span> -->
                  <span class="icon pr-icon pr-icon-edit" (click)="editDevice(i)">✏️</span>
                  <span class="icon" (click)="deleteDevice(i, device.id)">🗑️</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="square-box">
          <!-- Accessories Block Header -->
          <div class="block-title" style="display: flex; align-items: center; justify-content: space-between;">
            <span>Accessories</span>
            <button type="button" class="fab" [disabled]="!accessoriesHidden" (click)="accessoriesHidden = false"
              *ngIf="accessoriesHidden">+</button>
          </div>

          <div *ngIf="savedAccessories.length === 0 && accessoriesHidden" class="no-data-msg">
            No Accessories assigned
          </div>

          <!-- FORM Section (headers + input fields) -->
          <ng-container *ngIf="!accessoriesHidden">
            <!-- Form Header -->
            <div class="block-three">
              <div class="item">Accessory type</div>
              <div class="item">Model</div>
              <div class="item">Detail(Size)</div>
              <div class="item">Assignment date</div>
              <div class="item">Resupply Eligibility Date</div>
              <div class="item" style="width: 60px;">&nbsp;</div>
              <div class="internal-divider"></div>

              <!-- Form Inputs -->

              <!-- Accessory Type -->
              <div class="item">
                <select [(ngModel)]="selectedAccessory.type">
                  <option value="" disabled selected>Select</option>
                  <option *ngFor="let type of accessoryTypes" [value]="type">{{ type }}</option>
                </select>
              </div>

              <!-- Model (Based on Accessory Type) -->
              <div class="item">
                <select [(ngModel)]="selectedAccessory.model" [disabled]="!models.length">
                  <option value="" disabled selected>Select</option>
                  <option *ngFor="let model of models" [value]="model">{{ model }}</option>
                </select>
              </div>

              <!-- Detail/Size (Based on Accessory Type) -->
              <div class="item">
                <select [(ngModel)]="selectedAccessory.detail" [disabled]="!details.length">
                  <option value="" disabled selected>Select</option>
                  <option *ngFor="let detail of details" [value]="detail">{{ detail }}</option>
                </select>
              </div>

              <!-- Assignment Date -->
              <div class="item">
                <input type="date" [(ngModel)]="selectedAccessory.assignmentDate" />
              </div>

              <!-- Resupply Eligibility Date -->
              <div class="item">
                <input type="date" [(ngModel)]="selectedAccessory.resupplyDate" />
              </div>
            </div>

            <!-- Buttons -->
            <div class="button-wrapper">
              <div class="btn-group">
                <button class="btn-cancel" (click)="accessoriesHidden = true">Cancel</button>
                <button class="btn-save" (click)="saveAccessory()">Save</button>
              </div>
            </div>
          </ng-container>


          <!-- Divider -->
          <hr class="internal-divider" *ngIf="savedAccessories.length > 0" />

          <!-- SAVED ACCESSORIES Section -->
          <div *ngIf="savedAccessories.length > 0">
            <div class="block-three">

              <!-- ONLY show headers here if form is hidden -->
              <ng-container *ngIf="accessoriesHidden">
                <div class="item">Accessory type</div>
                <div class="item">Model</div>
                <div class="item">Detail</div>
                <div class="item">Assignment date</div>
                <div class="item">Resupply Eligibility Date</div>
                <div class="item" style="width: 60px;">&nbsp;</div>
                <div class="internal-divider"></div>
              </ng-container>

              <!-- Saved Entries -->
              <ng-container *ngFor="let accessory of savedAccessories; let i = index">
                <div class="item">{{ accessory.type }}</div>
                <div class="item">{{ accessory.model }}</div>
                <div class="item">{{ accessory.detail }}</div>
                <div class="item">{{ accessory.assignmentDate }}</div>
                <div class="item">{{ accessory.resupplyDate }}</div>
                <div class="item">
                  <span class="icon" (click)="editAccessory(accessory)">✏️</span>
                  <span class="icon" (click)="deleteAccessory(i)">🗑️</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="activeTab === 4">
        <div class="rules-section">
          <div class="rules-row">
            <label for="complianceRule">Compliance Rule</label>
            <select id="complianceRule">
              <option>Compliance Rule</option>
            </select>
          </div>
          <div class="rules-row">
            <label for="ruleSet">Rule Set</label>
            <select id="ruleSet" class="ruleset-select" [ngModel]="selectedRuleSetId" (ngModelChange)="selectedRuleSetId = $event">
              <option *ngFor="let set of ruleSets" [value]="set.id">{{set.title}}</option>
            </select>
          </div>
          <div class="rules-row">
            <label for="reminderSet">Reminder Set</label>
            <select id="reminderSet">
              <option>Default</option>
            </select>
          </div>
          <div class="rules-helper">Select one or more</div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <a *ngIf="activeTab > 0" class="footer-link" (click)="goToPreviousTab()" [class.disabled]="activeTab === 0">Previous</a>
      <div class="footer-actions">
        <a *ngIf="activeTab > 0 && activeTab < 4" class="footer-link" (click)="skipAllTabs()">Skip all</a>
        <button type="button" class="modal-save" [disabled]="!isCurrentFormValid()" (click)="saveCurrentTab()">{{ activeTab === 4 ? 'Finish' : 'Save' }}</button>
        <a *ngIf="activeTab > 0 && activeTab < 4" class="footer-link" (click)="skipCurrentTab()">Skip</a>
      </div>
    </div>
  </div>
</div>
